const API_BASE = process.env.REACT_APP_API_BASE_URL || '';
const TOKEN_ANAHTARI = 'kaldir_token';
const EPOSTA_ANAHTARI = 'kaldir_email';

export function tokenAl() {
  return localStorage.getItem(TOKEN_ANAHTARI);
}

export function epostaAl() {
  return localStorage.getItem(EPOSTA_ANAHTARI);
}

export function girisYapilmis() {
  return !!tokenAl();
}

function oturumKaydet(token, email) {
  localStorage.setItem(TOKEN_ANAHTARI, token);
  localStorage.setItem(EPOSTA_ANAHTARI, email);
  window.dispatchEvent(new Event('auth-changed'));
}

export function oturumuKapat() {
  localStorage.removeItem(TOKEN_ANAHTARI);
  localStorage.removeItem(EPOSTA_ANAHTARI);
  window.dispatchEvent(new Event('auth-changed'));
}

async function kimlikIstegi(yol, govde) {
  const response = await fetch(`${API_BASE}${yol}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(govde)
  });

  const veri = await response.json();

  if (!response.ok) {
    throw new Error(veri.error || 'İstek başarısız oldu');
  }

  oturumKaydet(veri.token, veri.email);
  return veri;
}

export function girisYap(email, sifre) {
  return kimlikIstegi('/api/auth/login', { email, password: sifre });
}

export function kayitOl(email, sifre) {
  return kimlikIstegi('/api/auth/register', { email, password: sifre });
}
